import { useSelectableIncidentTypesQuery } from "@common/hooks/useSelectableItemQueries.ts";

export function useIncidentLogTypesField(isPreview: boolean) {
    const { isLoading, data } = useSelectableIncidentTypesQuery(!isPreview);

    return { isLoading, incidentTypes: data };
}
